import { useCallback } from 'react';
import { useAppDispatch } from '@store/hooks/core';

import {
  useServerUiMutationHandler,
  useServerUiScope,
} from '../components/ServerUiDomainProvider';

import { serverUiApi } from './api';

/**
 * Manually invalidate the container tag and wait for the refetch to complete.
 * We avoid using invalidatesTags on the mutation endpoint because
 * dynamicMiddleware re-enters RTK Query's middleware chain, causing
 * the invalidation to fire twice per mutation fulfillment.
 */
export const useInvalidateAndRefetch = () => {
  const dispatch = useAppDispatch();
  const { containerKey, entityId } = useServerUiScope();
  const onComponentMutated = useServerUiMutationHandler();

  return useCallback(async () => {
    if (onComponentMutated) {
      await onComponentMutated();
      return;
    }
    if (!containerKey || !entityId) return;
    // eslint-disable-next-line @typescript-eslint/await-thenable -- RTK Query initiate returns a promise-like thunk result
    await dispatch(
      serverUiApi.endpoints.getV2ProviderContainersByContainerKey.initiate(
        { containerKey, entityId },
        { forceRefetch: true },
      ),
    );
  }, [dispatch, containerKey, entityId, onComponentMutated]);
};
